export default function intScrollHandler () {
    const anchorElements = document.querySelectorAll('a[href^="#"]');

    if (anchorElements.length === 0) {
        return;
    }

    anchorElements.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            const href = anchor.getAttribute('href');

            if (href.length <= 1) {
                return false;
            }

            const targetElement = document.querySelector(href);

            if (targetElement) {
                const offsetTop = targetElement.offsetTop;

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
}
